package de.oevbs.kunde.kundenportal2.model.services.digiservicecard

import de.oevbs.kunde.kundenportal2.ServiceInfo
import de.oevbs.sfa.communication.ClientDefinition
import de.oevbs.sfa.communication.ClientResponse

abstract class DigitalServiceCardClientDefinition(origin: String) : ClientDefinition(ServiceInfo, origin, ServiceInfo.name) {

    override val requestTimeoutMillis: Long = 30000L

    /**
     * Läd die Kfz-Vertragsdaten des eingeloggten Users/Partners aus dem CRM.
     *
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun init(): ClientResponse<DigitalServiceCardInit> =
        get("/digicard/init")


    /**
     * Stößt die Erstellung einer digitalen Kfz-Servicekarte für das Wallet über den Komposit-IVK-Servíce (Azure) an für 
     * den in [digitalServiceCard] ausgewählten Vertrag/Kennzeichen. Der Download-Link wird an die Mail im Partner
     * gesendet. Der Boolean [allowPushNotifications] im Datenmodell gibt an, ob der User der Werbung per Push 
     * zugestimmt hat. 
     * 
     * __Mocks__
     *
     * //TODO Mocks
     */
    suspend fun createCard(digitalServiceCard: DigitalServiceCard): ClientResponse<Unit> =
        post("/digicard/create", digitalServiceCard)

}